import React, { useState, useRef, useEffect, useContext } from "react";
import styles from "./GroupPhotos.module.scss";
import TinySlider from "tiny-slider-react";
import SliderControls from "./SliderButton";
import sliderStyles from "./TinySlider.module.scss";
import { animOnSwipe } from "../utils/animation";
import { getBoundingClientRect } from "../utils/helpers";
import { isMobile, isTablet } from "react-device-detect";
import ReactGA from "react-ga4";
import { Context } from "../Store";

const GroupPhotosNew = (props) => {
  const state = React.useContext(Context);
  const sliderRef = useRef();

  const settings = {
    lazyload: true,
    touch: true,
    nav: false,
    controlsContainer: "." + styles.sliderContainer + " .sliderControls",
    mouseDrag: true,
    loop: false,
    items: 1,
    gutter: 0,
    edgePadding: 0,
    responsive: {
      640: {
        items: state.groupPhotos.length < 2 ? state.groupPhotos.length : 2,
        gutter: 5,
        edgePadding: 0,
      },
      1024: {
        items: state.groupPhotos.length < 3 ? state.groupPhotos.length : 3,
        gutter: 5,
        edgePadding: 0,
      },
    },
  };

  let groupPhotoSources = state.groupPhotos.map((photo) => {
    return photo.thumbnail_url;
  });

  let groupPhotoMedia = state.groupPhotos.map((photo) => {
    return {
      mediaType: "PHOTO",
      mediaURI: photo.asset_uri,
      downloadURI: photo.thumbnail_url,
      sectionName: "Group Photo",
    };
  });

  useEffect(() => {
    animOnSwipe(sliderRef.current.slider);
  }, [sliderRef]);

  const handleHover = (index, e) => {
    let perviewDetails = {
      section: "GroupPhoto",
      index: index,
      mediaType: "PHOTO",
      mediaURI: state.groupPhotos[index].thumbnail_url,
      downloadURI: state.groupPhotos[index].asset_uri,
      sectionName: "Group Photo",
      target: e.currentTarget.querySelector("img"),
      timeStamp: e.timeStamp,
      groupLength: groupPhotoMedia.length,
      sources: groupPhotoSources,
      mediashare: groupPhotoMedia,
      type: "image",
    };
    props.handleHover(perviewDetails, e.type);
  };

  const openLightbox = (index) => {
    let lightboxDetails = {
      section: "GroupPhoto",
      index: index,
      sources: groupPhotoSources,
      mediashare: groupPhotoMedia,
      type: "image",
    };
    props.openLightbox(lightboxDetails);
  };

  let title = state.type == "1" || state.type == "3" ? "Photo Gallery" : "Group Photos";

  return (
    <div className={`section scale-slider section--with-share-arrow`}>
      <h2>The Group Shot</h2>
      <p>The moment, framed.</p>
      <div className={styles.sliderContainer}>
        <SliderControls slider={sliderRef}></SliderControls>

        <TinySlider settings={settings} ref={sliderRef}>
          {state.groupPhotos.map((photo, index) => (
            <div
              key={index}
              style={{ position: "relative" }}
              className={[sliderStyles.slide, styles.groupPhotoItem].join(" ")}
            >
              <div
                onClick={() => openLightbox(index)}
                onMouseEnter={isMobile ? () => false : handleHover.bind(this, index)}
                onMouseLeave={handleHover.bind(this, index)}
                style={{ cursor: "pointer" }}
              >
                <img src={photo.thumbnail_url} alt="" />
              </div>
            </div>
          ))}
        </TinySlider>
      </div>
    </div>
  );
};

export default GroupPhotosNew;
